/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The PartnerKey model module.
 * @module model/PartnerKey
 * @version 1.0.0
 */
export class PartnerKey {
  /**
   * Constructs a new <code>PartnerKey</code>.
   * @alias module:model/PartnerKey
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PartnerKey</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PartnerKey} obj Optional instance to populate.
   * @return {module:model/PartnerKey} The populated <code>PartnerKey</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PartnerKey();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('key'))
        obj.key = ApiClient.convertToType(data['key'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
PartnerKey.prototype._id = undefined;

/**
 * @member {String} key
 */
PartnerKey.prototype.key = undefined;

/**
 * @member {String} title
 */
PartnerKey.prototype.title = undefined;

/**
 * @member {String} description
 */
PartnerKey.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
PartnerKey.prototype.enabled = undefined;

/**
 * @member {String} created
 */
PartnerKey.prototype.created = undefined;

/**
 * @member {String} updated
 */
PartnerKey.prototype.updated = undefined;

